import { BrowserRouter, Routes as RouterRoutes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Header from './components/Header';
import ResearchPage from './pages/ResearchPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import PricingPage from './pages/PricingPage';
import SuccessPage from './pages/SuccessPage';
import AdminPage from './pages/AdminPage';
import AccountPage from './pages/AccountPage';
import NotFound from './pages/NotFound';

const Routes = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Header />
        <main className="pt-16">
          <RouterRoutes>
            <Route path="/" element={<ResearchPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/success" element={<SuccessPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/account" element={<AccountPage />} />
            <Route path="*" element={<NotFound />} />
          </RouterRoutes>
        </main>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default Routes;
